// extracted by mini-css-extract-plugin
module.exports = {"root":"CourseTitleBox_root__2chVh","facultyName":"CourseTitleBox_facultyName__1FbtD","facultyLogo":"CourseTitleBox_facultyLogo__2QMNN"};